import { CircleUser, Lock, Network, Settings } from 'lucide-react';

import { SettingsRoutes } from '@/router/routes';

import { SettingType } from '../types/setting-type';
import { SettingsNavigationGroup } from '../types/settings';

export const settingsNavigationConfig: SettingsNavigationGroup[] = [
  {
    group: 'account',
    icon: CircleUser,
    items: [
      { label: 'profileInfo', path: SettingsRoutes.ProfileInfo, type: SettingType.ProfileInfo },
      { label: 'password', path: SettingsRoutes.Password, type: SettingType.Password },
    ],
  },
  {
    group: 'orgStructure',
    icon: Network,
    items: [
      { label: 'departments', path: SettingsRoutes.Departments, type: SettingType.Departments },
      { label: 'seniorities', path: SettingsRoutes.Seniorities, type: SettingType.Seniorities },
      { label: 'roles', path: SettingsRoutes.Roles, type: SettingType.Roles },
    ],
  },
  {
    group: 'orgSettings',
    icon: Settings,
    items: [
      //TODO some screens are commented, since we will not be implementing them on MVP. Keep them commented for now
      { label: 'general', path: SettingsRoutes.General, type: SettingType.General },
      {
        label: 'externalRates',
        path: SettingsRoutes.Finance,
        type: SettingType.ExternalRates,
      },
      { label: 'timeOff', path: SettingsRoutes.TimeOff, type: SettingType.TimeOff },
      {
        label: 'integrations',
        path: SettingsRoutes.Integrations,
        type: SettingType.Integrations,
      },
      {
        label: 'customAttributes',
        path: SettingsRoutes.CustomAttributes,
        type: SettingType.CustomAttributes,
      },
      /*
      { label: 'api', path: SettingsRoutes.API, type: SettingType.API },
      { label: 'tags', path: SettingsRoutes.Tags, type: SettingType.Tags },*/
    ],
  },
  {
    group: 'access',
    icon: Lock,
    items: [
      { label: 'members', path: SettingsRoutes.Members, type: SettingType.MembersAccess },
      { label: 'permissions', path: SettingsRoutes.Permissions, type: SettingType.Permissions },
    ],
  },
];
